import { createSlice } from '@reduxjs/toolkit'; 

export interface CountyInitialState {
  selectedCounty: string
  loading: boolean
  error: string
  success: boolean
}

const initialState: CountyInitialState = {
  selectedCounty: '',
  loading: false,
  error: '',
  success: false,
}

export const CountySlice = createSlice({
  name: 'countySlice',
  initialState,
  reducers: {
    setSelectedCounty:(state,action)=> {
      state.selectedCounty = action.payload
    },
  }
})

export const CountyActions = {
    ...CountySlice.actions,
}

export const CountyReducer = CountySlice.reducer;
